import { Box, styled } from '@mui/material';

export const LocationCircle = styled(Box)`
  width: 20px;
  height: 20px;
  border-radius: 50px;
  flex-shrink: 0;
  border: 1px solid #c7c5c5;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;
`;
